import Title from "../../ui/title/Title"
import styles from './Loader.module.scss'
import { ReactNode } from "react"

type LoaderPayProps = {
	title?: string
	children?: ReactNode
}

const LoaderPay = ({ title = "Ожидаем оплату", children }: LoaderPayProps) => {
	return (
		<div className={styles.container}>
			<Title text={title} center />
			<LoaderCircle />
			{children}
		</div>
	)
}

export default LoaderPay

export function LoaderCircle() {
	return (
		<div className={styles.loading}>
			<div className={styles.loading_back} />
			<div className={styles.loading_svg}>
				<svg className={styles.circular_loader} viewBox="25 25 50 50" >
					<circle className={styles.loader_path} cx="50" cy="50" r="14" fill="none" stroke="#00DFAB" strokeWidth="2.5" />
				</svg>
			</div>
		</div>
	)
}
